<div class='flex'>
    <div class='row'>
        <div class='col-md-12 col-12'>
            <h1>Main</h1>
        </div>
    </div>
</div>